import React,{useState} from 'react';
import {useLocation} from 'react-router-dom';
import {addToken} from '../../store/actions/token';
import {connect} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {GetCookie,FormatDate} from '../../Utils';
import {HTMLRenderer} from '../../components/';

const SearchContent = ({tokenObject,addToken,connection}) => {

    const queryData = useLocation().search.replace("?","");
    const [Contents,setContents] = useState([]);

    const history = useHistory();

        if(tokenObject.token === ""){
            if(GetCookie('token') !== undefined){
                addToken(GetCookie('token'));
            }
        }
        
    function ReturnToContents(){
        history.push("/Contents");
    }

    (async function GetContent(){

        if(Contents.length === 0){
            let Content = await connection.get('/Contents/'+queryData,{
                headers:{
                    'user-access-token':tokenObject.token
                }
            });
    
            setContents([Content.data]);
        }
        
    })();

    console.log(Contents);

    if(Contents[0] !== null && Contents.length !== 0){
        return(
            <>
            <br/>
                <button className="btn btn-outline-primary" onClick={ReturnToContents}>Return to Contents</button>
                <br/>
                <br/>
                <h1>{Contents[0].Title}</h1>
                {FormatDate(Contents[0].Created_at)}
                <br/>
                <br/>
                <HTMLRenderer Content={Contents[0].Content}/>      
            </>
        )
    }else{
        return(<>
                <br/>
                <button className="btn btn-outline-primary" onClick={ReturnToContents}>Return to Contents</button>
                <br/>
                <br/>
                <h1>Content was not Found</h1>
            </>)
    }
    
}


const mapStateToProps = (state) => ({
    tokenObject: state.token
});


export default connect(mapStateToProps,{addToken})(SearchContent);